export const onScroll = {
  data () {
    return {
      active: false
    }
  },
  methods: {
    onScroll ({going}) {
      if (going === 'in') {
        this.active = true
      }
    }
  }
}

export const handleRoute = {
  methods: {
    handleRoute (obj) {
      this.$router.push(obj.path)
      if (obj.hash) {
        setTimeout(() => { this.$scrollTo(obj.hash) }, 150)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/resources/mixins.js